module.exports = __webpack_public_path__ + "static/eu-70ca14557f7a926076e1374d04711620.png";